import { ObjectWithDistanceProperty } from "@/lib/models/location";
import { Point } from "@/lib/util";

export function translateZorgbaseResult(item: ZorgbaseResult, locale: string): TranslatedZorgbaseResult {
	let translated = { ...item };

	switch (locale) {
		case 'en':
			translated.acceptsPatientsRestrictions = item.acceptsPatientsRestrictionsEnglish;
			translated.acceptsPassersByRestrictions = item.acceptsPassersByRestrictionsEnglish;
			return translated;
		default:
			return translated;
	}
}

export interface TranslatedZorgbaseResult extends ObjectWithDistanceProperty, Point {
	id: number;

	lastUpdated: string;

	visible: number;
	agbCode?: string;

	label: string;

	addressString: string;

	phoneNumber: string;
	url?: string;

	acceptsPatients?: number;
	acceptsPatientsUrl?: string;
	acceptsPatientsRestrictions?: string;

	acceptsPassersBy?: number;
	acceptsPassersByRestrictions?: string;

	isManaged?: number;

}

export default interface ZorgbaseResult extends TranslatedZorgbaseResult {
	acceptsPatientsRestrictionsEnglish?: string;
	acceptsPassersByRestrictionsEnglish?: string;
}
